import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { sortBy } from 'lodash';

@Component({
  selector: 'app-facility-select-dialog',
  templateUrl: './facility-select-dialog.component.html',
  styleUrls: ['./facility-select-dialog.component.scss']
})
export class FacilitySelectDialogComponent implements OnInit {

  facilities: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FacilitySelectDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.facilities = sortBy(this.data.facilities, ['name']);
  }

  selectAll() {
    this.facilities.forEach((f: any) => {
      f.selected = true;
    });
  }

  selectNone() {
    this.facilities.forEach((f: any) => {
      f.selected = false;
    });
  }

  done() {
    this.dialogRef.close(this.facilities);
  }

}
